export enum RegistrationFormDynamicField {
    FIRST_NAME = '8601',
    LAST_NAME = '8701',
    MIDDLE_NAME = '17901',
    MOBILE_NUMBER = '17501',
    EMAIL = '18001',
    NATIONALITY = '16601',
    DATE_OF_BIRTH = '15201',
    COUNTRY_OF_BIRTH = '17201',
    POSTAL_CODE = '4801',
    OCCUPATION = '15301',
    COUNTRY_OF_RESIDENCE = '39001',
  }

export const FIELD_REQUIRED_MESSAGE_KEYS: { [fieldId: string]: string } = {
  '8601': 'form.registrationForm.firstName.required',     // FIRST_NAME                                                                                                         
  '8701': 'form.registrationForm.lastName.required',      // LAST_NAME                                                                                                          
  '17901': 'form.registrationForm.middleName.optional',    // MIDDLE_NAME                                                                                                        
  '15201': 'page.registrationStep2Page.dateofBirth.relativeMaxDate', // DATE_OF_BIRTH
  '15301': 'form.registrationForm.occupation.required',   // OCCUPATION
  '4601': 'page.registrationStep3Page.addressCityRegex', // ADDRESS_CITY
  '4701': 'page.registrationStep3Page.addressRegionRegex', // ADDRESS_REGION
  '4801': 'page.registrationStep3Page.addressPostalCodeRegex', // POSTAL_CODE
  '46403': 'form.customerProfileForm.unitNumber.unitNumberRegex', // ADDRESS_UNIT_NUMBER
};

// Default pattern-error keys: intentionally empty so the BE-supplied per-destination
// message from /register and /recipient/fields can take effect at runtime. A per-country
// override below short-circuits that BE message for regions whose allowed-character set
// is known to diverge from the BE default (currently SG/MY).
export const FIELD_PATTERN_ERROR_MESSAGE_KEYS: { [fieldId: string]: string } = {};

// Per-country (app-region) overrides — take precedence over the BE-supplied message.
// Field IDs are mixed because each consumer indexes differently:
//   - Lite registration (rl-dynamic-fields) iterates BE field ids — numeric (8601/17901/8701)
//   - Full registration (registration-step2) indexes by FormGroup control name (firstName/middleName/lastName/lastName2)
//   - Recipient pages index by recipient/fields ids (firstName/middleName/lastName1/lastName2)
export const FIELD_PATTERN_ERROR_MESSAGE_KEYS_BY_COUNTRY: {
  [country: string]: { [fieldId: string]: string };
} = {
  SG: {
    '8601': 'page.nameValidation.allowedCharsSg',
    '17901': 'page.nameValidation.allowedCharsSg',
    '8701': 'page.nameValidation.allowedCharsSg',
    'firstName': 'page.nameValidation.allowedCharsSg',
    'middleName': 'page.nameValidation.allowedCharsSg',
    'lastName': 'page.nameValidation.allowedCharsSg',
    'lastName1': 'page.nameValidation.allowedCharsSg',
    'lastName2': 'page.nameValidation.allowedCharsSg',
  },
  MY: {
    '8601': 'page.nameValidation.allowedCharsMy',
    '17901': 'page.nameValidation.allowedCharsMy',
    '8701': 'page.nameValidation.allowedCharsMy',
    'firstName': 'page.nameValidation.allowedCharsMy',
    'middleName': 'page.nameValidation.allowedCharsMy',
    'lastName': 'page.nameValidation.allowedCharsMy',
    'lastName1': 'page.nameValidation.allowedCharsMy',
    'lastName2': 'page.nameValidation.allowedCharsMy',
  },
};

export function getFieldPatternErrorKey(fieldId: string, country?: string): string | undefined {
  const override = country && FIELD_PATTERN_ERROR_MESSAGE_KEYS_BY_COUNTRY[country];
  return (override && override[fieldId]) || FIELD_PATTERN_ERROR_MESSAGE_KEYS[fieldId];
}



// WEBPACK FOOTER //
// ./src/model/types/registration-form-dynamic-type.ts